import { render } from "./UiMotionList.vue?vue&type=template&id=75b2fe3f"
import script from "./UiMotionList.vue?vue&type=script&lang=js"
export * from "./UiMotionList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__